import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import Utils from "@/utils/utils";
import { ReactComponent as Logo } from "@/assets/icons/logo.svg";
import { ReactComponent as Download } from "@/assets/icons/download-pc.svg";
import { ReactComponent as Reback } from "@/assets/icons/reback.svg";
import { ReactComponent as NextThin } from "@/assets/icons/thin/next-page.svg";
import { ReactComponent as NextBold } from "@/assets/icons/bold/next-page.svg";
import { ReactComponent as PreThin } from "@/assets/icons/thin/pre-page.svg";
import { ReactComponent as PreBold } from "@/assets/icons/bold/pre-page.svg";
import { ReactComponent as Close } from "@/assets/icons/close-x.svg";
import "@/assets/navbar.scss";
import sentGAEvent from "@/ga";
export const NavbarRender = ({
  downloadClient,
  handleClick,
  handleCurrPage,
  uploading,
  fileToBlobStatus,
  work,
  menuList,
  pageMenuList,
  currPage,
  successFileGuids,
  currFile,
  submitting,
  uploadPercent,
  processPercent,
  theme,
}) => {
  const { t } = useTranslation(["navbar"]);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    sentGAEvent({
      category: "Tools_Ref",
      action: "Cut_PromptShow",
    });
  }, []);
  const removeClassName = () => {
    let arr = document.getElementsByClassName("ant-tooltip ant-tooltip-placement-right");
    arr[0].classList.add("ant-tooltip-hidden");
    setVisible(false);
    sentGAEvent({
      category: "Tools_Ref",
      action: "Cut_PromptCloseClick",
    });
  };
  const loginUrlSet = (country) => {
    let LOGIN_URL = "https://online.hitpaw.com/toolbox/cut-video-online/"
    console.log('country', country);
    let splitIndex, prefix, suffix, curCountry;
    if (country === 'ar' || country === 'tr') {
      // 拿到online前后的字符串，然后进行拼接
      splitIndex = LOGIN_URL.indexOf('online');
      prefix = LOGIN_URL.substring(0, splitIndex);
      suffix = LOGIN_URL.substring(splitIndex + 6);
    } else {
      // 拿到com前后的字符串，然后进行拼接
      splitIndex = LOGIN_URL.indexOf('com');
      if (country === 'br') {
        prefix = LOGIN_URL.substring(0, splitIndex + 3) + '.';
      } else {
        prefix = LOGIN_URL.substring(0, splitIndex);
      }
      suffix = LOGIN_URL.substring(country !== 'en' ? splitIndex + 3 : splitIndex);
    }
    curCountry = country === 'en' ? '' : country; //默认英文不需要
    let countryLogin = `${prefix}${curCountry}${suffix}`;
    console.log('countryLogin', countryLogin);
    return countryLogin;
  };
  const pushNewVersion = () => {
    const lang = Utils.getLanguage();
    let cutOnline = loginUrlSet(lang);
    window.location.href = cutOnline;
    sentGAEvent({
      category: "Tools_Ref",
      action: "Cut_PromptTryClick",
    });
  };

  const isShowToast = e => {
    if (e) {
      sentGAEvent({
        category: "Tools_Ref",
        action: "Cut_PromptShow",
      });
    }
  };

  const Toast = () => {
    return (
      <div className="tooltipContainer" style={{ width: 200 }}>
        <div className="tooltipTitle">
          <div className="tooltipCut">{t("Cut")}</div>
          {visible ? (
            <div>
              <Close className="tooltipCloseIcon" onClick={() => removeClassName()} />
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="tooltipDesc">
          {t("wanna")}{" "}
          <span className="tooltipTry" onClick={() => pushNewVersion()}>
            {t("try")}{" "}
          </span>
        </div>
      </div>
    );
  };
  return (
    <div className="Navbar">
      {work && !successFileGuids.length ? (
        <div className="nav-work">
          <span
            onClick={() => handleClick("")}
            className={`nav-reback ${(currFile ? submitting && (uploadPercent > 0 || processPercent > 0) : !fileToBlobStatus && (uploadPercent > 0 || processPercent > 0))
              ? "disabled"
              : ""
              }`}
          >
            <Reback />
          </span>
          {menuList
            .filter(item => item.key === work)
            .map(item => (
              <span className="nav-item" key={item.key}>
                <Tooltip
                  onVisibleChange={e => isShowToast(e)}
                  defaultVisible={true}
                  placement="right"
                  title={item.key === "cut" ? <Toast /> : t(item.title)}
                  onClick={() => handleClick(item.key)}
                >
                  {item.renderIcon()}
                </Tooltip>
              </span>
            ))}
        </div>
      ) : (
        <div className="nav-bottom" style={{ pointerEvents: uploading && !fileToBlobStatus ? "none" : "auto" }}>
          <a className="home-link" href={Utils.getHitPawHomeLink()} style={{ marginBottom: 38 }}>
            <Logo />
          </a>
          {pageMenuList.length > 1 && currPage > 0 ? (
            <div className="pre-icon page-btn" onClick={() => handleCurrPage(-1)}>
              {theme === "dark" ? <PreThin /> : <PreBold />}
            </div>
          ) : null}
          {pageMenuList.length
            ? pageMenuList[currPage].map(item => (
              <span className="nav-item" key={item.key}>
                <Tooltip placement="right" title={t(item.title)} onClick={() => handleClick(item.key)}>
                  {item.renderIcon()}
                </Tooltip>
              </span>
            ))
            : null}
          {pageMenuList.length > 1 && currPage < pageMenuList.length - 1 ? (
            <div className="next-icon page-btn" onClick={() => handleCurrPage(1)}>
              {theme === "dark" ? <NextThin /> : <NextBold />}
            </div>
          ) : null}
        </div>
      )}
      <a
        href={
          work === "removeWatermark"
            ? Utils.getHitPawWatermarkRemoverEXELink()
            : window.userClient.platform === "win"
              ? Utils.getHitPawVideoEditorEXELink()
              : Utils.getHitPawToolKitEXELink()
        }
        target="_blank"
        rel="noopener noreferrer"
        className="download"
        onClick={downloadClient}
      >
        <Download />
      </a>
    </div>
  );
};
